(function () {
  const root = document.querySelector('[data-product-page]');
  if (!root) return;

  const track = root.querySelector('.product-gallery-track');
  let items = Array.from(root.querySelectorAll('.product-gallery-item'));
  const jsonEl = root.querySelector('[data-product-json]');
  const variantInput = root.querySelector('[data-product-variant-id]');
  const addBtn = root.querySelector('[data-add-to-cart]');
  const buyBtn = root.querySelector('[data-buy-now]');
  const returnTo = root.querySelector('[data-return-to]');
  const priceEl = root.querySelector('.product-price-amount[data-product-price]');
  const compareEl = root.querySelector('[data-product-compare]');
  const shareBtn = root.querySelector('[data-product-share]');
  const wishlistBtn = root.querySelector('[data-wishlist-btn]');
  let optionButtons = Array.from(root.querySelectorAll('[data-option-value]'));
  const payload = jsonEl ? JSON.parse(jsonEl.textContent) : {};
  const variants = Array.isArray(payload) ? payload : payload.variants || [];
  const productImages = Array.isArray(payload.images) ? payload.images : [];
  const optionNames = Array.isArray(payload.options) ? payload.options : [];
  const moneyFormat =
    payload.money_format ||
    root.getAttribute('data-money-format') ||
    window.Shopify?.money_format ||
    '₹{{amount}}';

  let activeIndex = 0;
  let applyingFromGallery = false;

  function refreshOptionButtons() {
    optionButtons = Array.from(root.querySelectorAll('[data-option-value]'));
  }

  function optionIndexByName(name) {
    if (!name) return -1;
    const needle = String(name).toLowerCase();
    return optionNames.findIndex((n) => String(n).toLowerCase() === needle);
  }

  function colourOptionIndex() {
    return optionNames.findIndex((n) => /colou?r/i.test(String(n)));
  }

  function sizeOptionIndex() {
    return optionNames.findIndex((n) => /size/i.test(String(n)));
  }

  function variantOptions(variant) {
    return [variant.option1, variant.option2, variant.option3];
  }

  function variantImageId(variant) {
    const id = variant?.featured_image?.id;
    return id != null ? String(id) : '';
  }

  function isDesktopGallery() {
    return window.matchMedia('(min-width: 900px)').matches;
  }

  function lockPageScroll() {
    return window.scrollY || window.pageYOffset || 0;
  }

  function restorePageScroll(y) {
    if (y == null) return;
    const apply = () => {
      window.scrollTo(0, y);
      document.documentElement.scrollTop = y;
      document.body.scrollTop = y;
    };
    apply();
    requestAnimationFrame(apply);
  }

  /** Scroll page up so the main/hero gallery image is in view under the header. */
  function scrollToMainImage() {
    const hero =
      track?.querySelector('.product-gallery-item.is-gallery-main') ||
      track?.firstElementChild;
    const gallery =
      root.querySelector('.product-gallery') ||
      root.querySelector('.product-gallery-column') ||
      hero;
    if (!gallery) return;

    const headerH =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
        10,
      ) ||
      document.querySelector('.site-header')?.offsetHeight ||
      63;
    const top =
      (window.scrollY || window.pageYOffset || 0) +
      gallery.getBoundingClientRect().top -
      headerH -
      8;

    window.scrollTo(0, Math.max(0, top));
  }

  function readGalleryItemState(item) {
    const img = item?.querySelector('img');
    return {
      id: item?.getAttribute('data-image-id') || '',
      src: img?.getAttribute('src') || img?.src || '',
      alt: img?.getAttribute('alt') || '',
      width: img?.getAttribute('width') || '',
      height: img?.getAttribute('height') || '',
    };
  }

  function writeGalleryItemState(item, state) {
    if (!item || !state) return;
    if (state.id) item.setAttribute('data-image-id', state.id);
    else item.removeAttribute('data-image-id');
    let img = item.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.className = 'product-gallery-image';
      item.appendChild(img);
    }
    if (state.id) img.setAttribute('data-image-id', state.id);
    else img.removeAttribute('data-image-id');
    if (state.alt != null) img.setAttribute('alt', state.alt);
    if (state.width) img.setAttribute('width', state.width);
    if (state.height) img.setAttribute('height', state.height);
    if (state.src) {
      // Force visible update even if browser thinks src is unchanged
      img.setAttribute('src', state.src);
      if (img.src !== state.src && !String(img.src).includes(String(state.src).replace(/^https?:/, ''))) {
        img.src = state.src;
      }
    }
  }

  function syncGalleryWidthFromMain() {
    const column = root.querySelector('[data-product-gallery-column]');
    const img = track?.firstElementChild?.querySelector('img');
    if (!column || !img) return;

    const apply = (w, h) => {
      if (!(w > 0 && h > 0)) return;
      column.style.setProperty('--pdp-img-w', String(w));
      column.style.setProperty('--pdp-img-h', String(h));
    };

    const attrW = Number(img.getAttribute('width'));
    const attrH = Number(img.getAttribute('height'));
    if (attrW > 0 && attrH > 0) {
      apply(attrW, attrH);
      return;
    }

    if (img.naturalWidth > 0 && img.naturalHeight > 0) {
      apply(img.naturalWidth, img.naturalHeight);
      return;
    }

    img.addEventListener(
      'load',
      () => {
        if (img.naturalWidth > 0 && img.naturalHeight > 0) {
          apply(img.naturalWidth, img.naturalHeight);
        }
      },
      {once: true},
    );
  }

  function syncGalleryActiveState(activeItem) {
    items = Array.from(root.querySelectorAll('.product-gallery-item'));
    const activeId =
      activeItem?.getAttribute('data-image-id') ||
      track?.firstElementChild?.getAttribute('data-image-id') ||
      '';
    items.forEach((el, i) => {
      const isMain = isDesktopGallery() ? i === 0 : el === activeItem;
      el.classList.toggle('is-gallery-main', isMain);
      el.setAttribute('aria-current', isMain ? 'true' : 'false');
      el.setAttribute('aria-hidden', isMain ? 'false' : 'true');
    });
    if (activeId) {
      items.forEach((el) => {
        el.classList.toggle(
          'is-gallery-selected',
          el.getAttribute('data-image-id') === activeId,
        );
      });
    }
    syncGalleryWidthFromMain();
  }

  function goTo(index) {
    items = Array.from(root.querySelectorAll('.product-gallery-item'));
    if (!track || !items.length) return;
    activeIndex = (index + items.length) % items.length;
    // Mobile carousel only — never scroll the page
    if (!isDesktopGallery()) {
      const width = track.clientWidth || track.offsetWidth || window.innerWidth || 0;
      if (width > 0) {
        track.scrollTo({left: activeIndex * width, behavior: 'auto'});
      } else {
        requestAnimationFrame(() => {
          const w = track.clientWidth || track.offsetWidth || window.innerWidth || 0;
          if (w > 0) track.scrollTo({left: activeIndex * w, behavior: 'auto'});
        });
      }
    }
    syncGalleryActiveState(items[activeIndex]);
  }

  /**
   * Show the chosen image as the main/hero image.
   * Desktop: move that node into the first (hero) slot — :first-child is the large main image.
   * Mobile: slide carousel to that image.
   * Then scroll up so the main image is visible.
   */
  function promoteGalleryItem(item, options) {
    if (!item || !track) return;
    const shouldScrollToMain = !options || options.scrollToMain !== false;
    items = Array.from(root.querySelectorAll('.product-gallery-item'));

    if (!isDesktopGallery()) {
      const index = items.indexOf(item);
      if (index >= 0) goTo(index);
      if (shouldScrollToMain) scrollToMainImage();
      return;
    }

    // Move clicked image into hero position so it becomes the main image
    if (item !== track.firstElementChild) {
      track.insertBefore(item, track.firstElementChild);
    }

    activeIndex = 0;
    syncGalleryActiveState(track.firstElementChild);

    if (document.activeElement && track.contains(document.activeElement)) {
      try {
        document.activeElement.blur();
      } catch (e) {
        /* ignore */
      }
    }

    if (shouldScrollToMain) scrollToMainImage();
  }

  function selectedOptions() {
    refreshOptionButtons();
    const selected = [];
    optionButtons.forEach((btn) => {
      const index = Number(btn.getAttribute('data-option-index'));
      if (btn.classList.contains('selected')) selected[index] = btn.getAttribute('data-option-value');
    });
    return selected;
  }

  function findVariant() {
    const selected = selectedOptions();
    return (
      variants.find((variant) => {
        return variantOptions(variant).every((value, i) => {
          if (selected[i] == null || selected[i] === '') return true;
          return value === selected[i];
        });
      }) || null
    );
  }

  function colourFromImageMeta(imageId) {
    const colourIdx = colourOptionIndex();
    if (colourIdx < 0 || !imageId) return null;
    const imgMeta = productImages.find((img) => String(img.id) === String(imageId));
    const alt = String(imgMeta?.alt || '');
    const colourValues = [
      ...new Set(variants.map((v) => variantOptions(v)[colourIdx]).filter(Boolean)),
    ].sort((a, b) => String(b).length - String(a).length);

    const suffix = alt.includes('—')
      ? alt.slice(alt.lastIndexOf('—') + 1)
      : alt.includes('–')
        ? alt.slice(alt.lastIndexOf('–') + 1)
        : alt.includes(' - ')
          ? alt.slice(alt.lastIndexOf(' - ') + 3)
          : alt;
    const hay = suffix.toLowerCase();
    for (const colour of colourValues) {
      const re = new RegExp(`(^|[^a-z])${String(colour).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}([^a-z]|$)`, 'i');
      if (re.test(hay)) return colour;
    }
    return null;
  }

  function pickVariantFromMatches(matches) {
    if (!matches.length) return null;
    const selected = selectedOptions();
    const sizeIdx = sizeOptionIndex();
    const colourIdx = colourOptionIndex();
    const currentSize = sizeIdx >= 0 ? selected[sizeIdx] : null;

    // Prefer same size + other selected non-colour options
    const preferred = matches.find((v) => {
      const opts = variantOptions(v);
      return opts.every((value, i) => {
        if (i === colourIdx) return true;
        if (selected[i] == null || selected[i] === '') return true;
        return value === selected[i];
      });
    });
    if (preferred) return preferred;

    if (currentSize != null && sizeIdx >= 0) {
      const sameSize = matches.find(
        (v) => variantOptions(v)[sizeIdx] === currentSize && v.available,
      );
      if (sameSize) return sameSize;
    }

    return matches.find((v) => v.available) || matches[0];
  }

  function findVariantForImage(imageId) {
    if (!imageId) return null;
    const id = String(imageId);
    let matches = variants.filter((v) => variantImageId(v) === id);

    if (!matches.length) {
      const imgMeta = productImages.find((img) => String(img.id) === id);
      if (imgMeta?.src) {
        const stem = normalizeSrc(imgMeta.src);
        matches = variants.filter((v) => {
          const src = normalizeSrc(variantImageSrc(v));
          return src && (src === stem || src.includes(stem) || stem.includes(src));
        });
      }
    }

    // Same colour, different shot (e.g. "Orange 2") — map via alt colour name
    if (!matches.length) {
      const colour = colourFromImageMeta(id);
      const colourIdx = colourOptionIndex();
      if (colour && colourIdx >= 0) {
        matches = variants.filter((v) => variantOptions(v)[colourIdx] === colour);
      }
    }

    return pickVariantFromMatches(matches);
  }

  function selectOptionsFromVariant(variant) {
    if (!variant) return;
    refreshOptionButtons();
    const opts = variantOptions(variant);
    optionButtons.forEach((btn) => {
      const index = Number(btn.getAttribute('data-option-index'));
      const value = btn.getAttribute('data-option-value');
      const match = opts[index] === value;
      btn.classList.toggle('selected', match);
      btn.setAttribute('aria-pressed', match ? 'true' : 'false');
    });
  }

  function updateOptionAvailability() {
    refreshOptionButtons();
    const selected = selectedOptions();
    const colourIdx = colourOptionIndex();
    const sizeIdx = sizeOptionIndex();

    optionButtons.forEach((btn) => {
      const index = Number(btn.getAttribute('data-option-index'));
      const value = btn.getAttribute('data-option-value');
      const available = variants.some((variant) => {
        if (!variant.available) return false;
        const opts = variantOptions(variant);
        if (opts[index] !== value) return false;
        return opts.every((optVal, i) => {
          if (i === index) return true;
          // Size buttons: must match selected colour (and other non-size options)
          if (index === sizeIdx && colourIdx >= 0 && i === colourIdx) {
            if (selected[colourIdx] == null || selected[colourIdx] === '') return true;
            return optVal === selected[colourIdx];
          }
          // Colour buttons: ignore size so colours stay visible across sizes
          if (index === colourIdx && i === sizeIdx) return true;
          if (selected[i] == null || selected[i] === '') return true;
          return optVal === selected[i];
        });
      });
      btn.disabled = !available;
      btn.classList.toggle('is-unavailable', !available);
      btn.setAttribute('aria-disabled', available ? 'false' : 'true');

      // Only show sizes available for the current colour/variation
      if (index === sizeIdx) {
        btn.hidden = !available;
        btn.style.setProperty('display', available ? '' : 'none', 'important');
      } else {
        btn.hidden = false;
        btn.style.removeProperty('display');
      }
    });

    // If selected size is unavailable for current colour, pick first available size
    if (sizeIdx >= 0) {
      const sizeBtns = optionButtons.filter(
        (btn) => Number(btn.getAttribute('data-option-index')) === sizeIdx,
      );
      const selectedSizeBtn = sizeBtns.find((btn) => btn.classList.contains('selected'));
      if (selectedSizeBtn && (selectedSizeBtn.disabled || selectedSizeBtn.hidden)) {
        const next = sizeBtns.find((btn) => !btn.disabled && !btn.hidden);
        if (next) {
          sizeBtns.forEach((btn) => {
            const match = btn === next;
            btn.classList.toggle('selected', match);
            btn.setAttribute('aria-pressed', match ? 'true' : 'false');
          });
        }
      }
    }
  }

  function formatWithDelimiter(n, precision, thousands, decimal) {
    const fixed = Number(n).toFixed(precision);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents) {
    const value = Number(cents) / 100;
    const format = String(moneyFormat || '₹{{amount}}');
    // Prefer shop money format so the currency symbol never flips on variant change
    if (window.Shopify?.formatMoney) {
      try {
        return window.Shopify.formatMoney(cents, format);
      } catch (error) {
        /* fall through */
      }
    }
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatWithDelimiter(value, 2, ',', '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, formatWithDelimiter(value, 0, ',', '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, formatWithDelimiter(value, 2, ',', '.'))
      .replace(/\{\{\s*amount_with_period_and_comma_separator\s*\}\}/g, formatWithDelimiter(value, 2, '.', ','))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatWithDelimiter(value, 2, "'", '.'));
  }

  function variantImageSrc(variant) {
    const img = variant?.featured_image || variant?.image;
    if (!img) return '';
    if (typeof img === 'string') return img;
    return img.src || img.url || '';
  }

  function normalizeSrc(src) {
    if (!src) return '';
    return String(src)
      .split('?')[0]
      .replace(/^https?:/, '')
      .replace(/_\d+x\d*(?=\.|$)/g, '');
  }

  function imageMetaForVariant(variant) {
    const imageId = variant?.featured_image?.id != null ? String(variant.featured_image.id) : '';
    if (imageId) {
      const fromProduct = productImages.find((img) => String(img.id) === imageId);
      if (fromProduct) return fromProduct;
    }

    const direct = variantImageSrc(variant);
    if (direct) {
      const stem = normalizeSrc(direct);
      const bySrc = productImages.find((img) => {
        const candidate = normalizeSrc(img.src);
        return candidate === stem || candidate.includes(stem) || stem.includes(candidate);
      });
      if (bySrc) return bySrc;
      return {
        id: imageId,
        src: direct,
        alt: variant.name || variant.title || '',
        width: variant.featured_image?.width || '',
        height: variant.featured_image?.height || '',
      };
    }

    // Fallback: match gallery image by colour name in alt text
    const colourIdx = colourOptionIndex();
    const colour = colourIdx >= 0 ? variantOptions(variant)[colourIdx] : null;
    if (colour) {
      const colourNeedle = String(colour).toLowerCase();
      const byColour = productImages.find((img) => {
        const alt = String(img.alt || '').toLowerCase();
        const re = new RegExp(
          `(^|[^a-z])${colourNeedle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}([^a-z]|$)`,
          'i',
        );
        return re.test(alt);
      });
      if (byColour) return byColour;
    }
    return null;
  }

  function gallerySrcForVariant(variant) {
    return imageMetaForVariant(variant)?.src || variantImageSrc(variant) || '';
  }

  function findGalleryIndex(variant) {
    const meta = imageMetaForVariant(variant);
    const src = meta?.src || variantImageSrc(variant);
    const imageId =
      (meta?.id != null && String(meta.id)) ||
      (variant?.featured_image?.id != null ? String(variant.featured_image.id) : '');
    items = Array.from(root.querySelectorAll('.product-gallery-item'));

    if (imageId) {
      const byId = items.findIndex(
        (item) =>
          item.getAttribute('data-image-id') === imageId ||
          !!item.querySelector(`[data-image-id="${imageId}"]`),
      );
      if (byId >= 0) return byId;
    }

    if (!src) return -1;
    const stem = normalizeSrc(src);
    return items.findIndex((item) => {
      const img = item.querySelector('img');
      if (!img) return false;
      const candidate = normalizeSrc(img.getAttribute('src') || img.src || '');
      return (
        candidate === stem ||
        (stem && candidate.includes(stem)) ||
        (candidate && stem.includes(candidate))
      );
    });
  }

  function setHeroImage(variant, options) {
    if (applyingFromGallery) return;
    const meta = imageMetaForVariant(variant);
    const src = meta?.src || '';
    const imageId = meta?.id != null ? String(meta.id) : '';
    if ((!src && !imageId) || !track) return;
    const shouldScrollToMain = !options || options.scrollToMain !== false;

    items = Array.from(root.querySelectorAll('.product-gallery-item'));
    const matchIndex = findGalleryIndex(variant);
    const state = {
      id: imageId,
      src,
      alt: meta?.alt || variant.name || variant.title || 'Product image',
      width: meta?.width || variant.featured_image?.width || '',
      height: meta?.height || variant.featured_image?.height || '',
    };

    // Desktop: move into hero slot. Mobile: jump carousel.
    if (matchIndex >= 0) {
      const target = items[matchIndex];
      writeGalleryItemState(target, state);
      promoteGalleryItem(target, {scrollToMain: shouldScrollToMain});
      syncGalleryWidthFromMain();
      return;
    }

    let hero = items[0];
    if (!hero) {
      hero = document.createElement('div');
      hero.className = 'product-gallery-item';
      hero.setAttribute('role', 'button');
      hero.setAttribute('tabindex', '0');
      track.appendChild(hero);
    }
    writeGalleryItemState(hero, state);

    if (!isDesktopGallery()) {
      requestAnimationFrame(() => {
        goTo(0);
        if (shouldScrollToMain) scrollToMainImage();
      });
    } else {
      items = Array.from(root.querySelectorAll('.product-gallery-item'));
      items.forEach((el, i) => {
        el.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      });
      activeIndex = 0;
      syncGalleryActiveState(track.firstElementChild);
      if (shouldScrollToMain) scrollToMainImage();
    }
    syncGalleryWidthFromMain();
  }

  function applyVariant(variant, options) {
    if (!variant || !variantInput) return;
    const skipHero = options && options.skipHero;
    const scrollToMain = !options || options.scrollToMain !== false;
    variantInput.value = variant.id;
    const money = formatMoney(variant.price);
    if (priceEl) priceEl.textContent = money;
    if (wishlistBtn) {
      wishlistBtn.setAttribute('data-wishlist-price', money);
      wishlistBtn.setAttribute('data-variant-id', String(variant.id));
      const imgSrc = variantImageSrc(variant);
      if (imgSrc) wishlistBtn.setAttribute('data-product-image', imgSrc);
    }
    if (compareEl) {
      const onSale = variant.compare_at_price > variant.price;
      compareEl.hidden = !onSale;
      if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
    }
    const available = variant.available;
    [addBtn, buyBtn].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !available;
      if (btn === addBtn) btn.textContent = available ? 'Add to Cart' : 'Sold Out';
    });

    // Reflect all option values (colour, size, extras)
    selectOptionsFromVariant(variant);
    updateOptionAvailability();

    // After availability may have changed size, re-resolve exact variant
    const resolved = findVariant() || variant;
    if (resolved.id !== variant.id) {
      variantInput.value = resolved.id;
      selectOptionsFromVariant(resolved);
      updateOptionAvailability();
    }

    if (!skipHero) setHeroImage(resolved, {scrollToMain});

    // Keep URL in sync without reload
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(resolved.id));
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      /* ignore */
    }
  }

  function onOptionClick(btn) {
    if (btn.disabled || btn.hidden) return;
    refreshOptionButtons();
    const index = Number(btn.getAttribute('data-option-index'));
    const sizeIdx = sizeOptionIndex();
    const isSizeClick = sizeIdx >= 0 && index === sizeIdx;

    optionButtons
      .filter((other) => Number(other.getAttribute('data-option-index')) === index)
      .forEach((other) => other.classList.toggle('selected', other === btn));
    updateOptionAvailability();

    // Size change: update price/availability only — no gallery jump or page scroll
    applyVariant(findVariant() || variants.find((v) => v.available) || variants[0], {
      skipHero: isSizeClick,
      scrollToMain: !isSizeClick,
    });
  }

  function bindOptionClicks() {
    refreshOptionButtons();
    optionButtons.forEach((btn) => {
      if (btn.dataset.boundOption === '1') return;
      btn.dataset.boundOption = '1';
      btn.addEventListener('click', () => onOptionClick(btn));
    });
  }

  function syncVariantFromGalleryItem(item) {
    if (!item || applyingFromGallery) return false;
    const imageId =
      item.getAttribute('data-image-id') ||
      item.querySelector('[data-image-id]')?.getAttribute('data-image-id');
    const variant = findVariantForImage(imageId);
    if (!variant) return false;

    // Already on this variant — just mark gallery state
    if (variantInput && String(variantInput.value) === String(variant.id)) {
      syncGalleryActiveState(item);
      return true;
    }

    applyingFromGallery = true;
    try {
      applyVariant(variant, {skipHero: true});
      syncGalleryActiveState(item);
    } finally {
      applyingFromGallery = false;
    }
    return true;
  }

  function onGalleryItemActivate(item) {
    if (!item || !track) return;
    applyingFromGallery = true;
    try {
      promoteGalleryItem(item, {scrollToMain: true});
      const imageId =
        item.getAttribute('data-image-id') ||
        item.querySelector('[data-image-id]')?.getAttribute('data-image-id');
      const variant = findVariantForImage(imageId);
      if (variant) {
        applyVariant(variant, {skipHero: true});
      } else {
        updateOptionAvailability();
      }
    } finally {
      applyingFromGallery = false;
      if (document.activeElement && track.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      scrollToMainImage();
    }
  }

  function bindGalleryClicks() {
    if (!track) return;
    track.addEventListener('click', (event) => {
      const item = event.target?.closest?.('.product-gallery-item');
      if (!item || !track.contains(item)) return;
      event.preventDefault();
      onGalleryItemActivate(item);
    });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const item = event.target?.closest?.('.product-gallery-item');
      if (!item || !track.contains(item)) return;
      event.preventDefault();
      onGalleryItemActivate(item);
    });
  }

  /** Mobile swipe: when carousel settles on an image, update colour/size to match. */
  let galleryScrollSyncTimer = null;
  function syncVariantFromCarouselPosition() {
    if (isDesktopGallery() || applyingFromGallery || !track) return;
    items = Array.from(root.querySelectorAll('.product-gallery-item'));
    const width = track.clientWidth || track.offsetWidth || 0;
    if (!width || !items.length) return;
    activeIndex = Math.round(track.scrollLeft / width);
    activeIndex = Math.max(0, Math.min(activeIndex, items.length - 1));
    syncVariantFromGalleryItem(items[activeIndex]);
  }

  if (track && items.length > 1) {
    track.addEventListener(
      'scroll',
      () => {
        if (isDesktopGallery()) return;
        const width = track.clientWidth;
        if (!width) return;
        activeIndex = Math.round(track.scrollLeft / width);
        clearTimeout(galleryScrollSyncTimer);
        galleryScrollSyncTimer = setTimeout(syncVariantFromCarouselPosition, 140);
      },
      {passive: true},
    );
    track.addEventListener('scrollend', syncVariantFromCarouselPosition, {passive: true});
    root.querySelector('.product-gallery-nav--prev')?.addEventListener('click', () => {
      goTo(activeIndex - 1);
      requestAnimationFrame(syncVariantFromCarouselPosition);
    });
    root.querySelector('.product-gallery-nav--next')?.addEventListener('click', () => {
      goTo(activeIndex + 1);
      requestAnimationFrame(syncVariantFromCarouselPosition);
    });
  }

  bindGalleryClicks();
  bindOptionClicks();

  // Ensure initial colour shows its own main image + option availability
  applyVariant(findVariant() || variants.find((v) => v.available) || variants[0]);
  syncGalleryWidthFromMain();
  window.addEventListener('resize', syncGalleryWidthFromMain);

  buyBtn?.addEventListener('click', () => {
    if (returnTo) returnTo.value = '/checkout';
  });
  addBtn?.addEventListener('click', () => {
    if (returnTo) returnTo.value = '/cart';
  });

  shareBtn?.addEventListener('click', async () => {
    try {
      if (navigator.share) {
        await navigator.share({title: document.title, url: window.location.href});
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(window.location.href);
      }
    } catch (error) {
      /* ignore cancel */
    }
  });

  // Size guide modal — closed by default; only opens on Size Chart click
  const sizeModal = document.querySelector('[data-size-guide-modal]');
  const openSizeBtns = document.querySelectorAll('[data-size-guide-open]');
  function openSizeGuide(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!sizeModal) return;
    sizeModal.hidden = false;
    sizeModal.classList.add('size-guide-modal--open', 'active');
    document.body.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    if (!sizeModal) return;
    sizeModal.hidden = true;
    sizeModal.classList.remove('size-guide-modal--open', 'active');
    document.body.style.overflow = '';
  }
  closeSizeGuide();
  openSizeBtns.forEach((btn) => btn.addEventListener('click', openSizeGuide));
  sizeModal?.querySelector('[data-size-guide-close]')?.addEventListener('click', closeSizeGuide);
  sizeModal?.addEventListener('click', (event) => {
    if (event.target === sizeModal) closeSizeGuide();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && sizeModal && !sizeModal.hidden) closeSizeGuide();
  });
  const howtoBtn = sizeModal?.querySelector('[data-size-guide-howto]');
  const howtoPanel = sizeModal?.querySelector('[data-size-guide-howto-panel]');
  howtoBtn?.addEventListener('click', () => {
    const open = howtoBtn.getAttribute('aria-expanded') === 'true';
    howtoBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
    howtoBtn.classList.toggle('is-open', !open);
    if (howtoPanel) howtoPanel.hidden = open;
  });
  sizeModal?.querySelectorAll('[data-size-unit]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const unit = btn.getAttribute('data-size-unit');
      sizeModal.querySelectorAll('[data-size-unit]').forEach((el) => {
        el.classList.toggle('is-active', el === btn);
      });
      sizeModal.querySelectorAll('[data-size-table]').forEach((table) => {
        table.hidden = table.getAttribute('data-size-table') !== unit;
      });
    });
  });

  function selectSizeChartIndex(index) {
    const idx = String(index);
    sizeModal.querySelectorAll('[data-size-chart-index]').forEach((btn) => {
      const selected = btn.getAttribute('data-size-chart-index') === idx;
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      const label = (btn.textContent || '').trim();
      if (selected) {
        if (!btn.querySelector('.size-chart-cell-selected')) {
          btn.innerHTML = '<span class="size-chart-cell-selected">' + label + '</span>';
        }
      } else if (btn.querySelector('.size-chart-cell-selected')) {
        btn.textContent = label;
      }
    });

    // Sync product size option buttons when labels match (32/34… or S/M…)
    const selectedBtn = sizeModal.querySelector(
      '[data-size-chart-index="' + idx + '"][aria-pressed="true"]',
    );
    const selectedLabel = selectedBtn
      ? (selectedBtn.textContent || '').trim()
      : '';
    if (selectedLabel) {
      root.querySelectorAll('.product-size-grid [data-option-value]').forEach((opt) => {
        const value = opt.getAttribute('data-option-value') || '';
        if (value === selectedLabel || value.toUpperCase() === selectedLabel.toUpperCase()) {
          opt.click();
        }
      });
    }
  }

  sizeModal?.querySelectorAll('[data-size-chart-index]').forEach((btn) => {
    btn.addEventListener('click', () => {
      selectSizeChartIndex(btn.getAttribute('data-size-chart-index'));
    });
  });

  /* Product info accordions — only one open at a time */
  const accordionRoot = root.querySelector('.product-accordions');
  if (accordionRoot) {
    const panels = Array.from(accordionRoot.querySelectorAll(':scope > details'));
    panels.forEach((panel) => {
      panel.addEventListener('toggle', () => {
        if (!panel.open) return;
        panels.forEach((other) => {
          if (other !== panel && other.open) other.open = false;
        });
      });
    });
  }
})();
